import Parse from "parse";

//Parse.initialize(clientselector.getParseAppId());
//Parse.serverURL = clientselector.getParseHost();

Parse.initialize("openinc-service-demo");
Parse.serverURL = "https://parse-service.apps.openinc.dev/parse";
